import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import GameScreenLayout from "@/components/GameScreenLayout"
import { useBattleChallenge } from "@/features/battle/BattleChallengeContext"
import { useGuardiansPassport } from "@/features/passport/GuardiansPassportContext"
import { formatOutgoingChallengeModeLabel } from "@/constants/battleLabels"
import { CHALLENGE_TIMEOUT_SEC, formatPointsValue } from "@/constants/game.constants"

export default function ChallengeWaitingPage() {
  const navigate = useNavigate()
  const { passport } = useGuardiansPassport()
  const { outgoingChallenge, cancelOutgoing, clearOutgoing } = useBattleChallenge()
  const [timerSec, setTimerSec] = useState(CHALLENGE_TIMEOUT_SEC)

  useEffect(() => {
    if (!outgoingChallenge) {
      navigate("/play/online-players", { replace: true })
    }
  }, [outgoingChallenge, navigate])

  useEffect(() => {
    if (!outgoingChallenge) return
    setTimerSec(outgoingChallenge.expiresInSec || CHALLENGE_TIMEOUT_SEC)
    const interval = window.setInterval(() => {
      setTimerSec((prev) => Math.max(0, prev - 1))
    }, 1000)
    return () => window.clearInterval(interval)
  }, [outgoingChallenge])

  if (!outgoingChallenge) {
    return (
      <GameScreenLayout title="Ожидание" backTo="/play">
        <p className="text-sm text-guardians-muted">Нет активного вызова</p>
      </GameScreenLayout>
    )
  }

  const { target, searchMode, colorRank } = outgoingChallenge

  function handleCancel() {
    cancelOutgoing()
    clearOutgoing()
    navigate(-1)
  }

  return (
    <GameScreenLayout title="Ожидание ответа" backTo="/play/online-players">
      <div className="flex flex-col items-center py-8 text-center">
        <p className="text-lg font-medium text-guardians-accent">Ожидаем ответ…</p>
        <p className="mt-2 text-sm text-guardians-muted">
          {formatOutgoingChallengeModeLabel(searchMode, colorRank)}
        </p>
        <div className="mt-6 w-full rounded-xl border border-white/10 bg-white/5 p-4 text-sm">
          <p className="font-medium">{target.nickname}</p>
          <p className="text-guardians-muted">{target.publicGameCode}</p>
          <p className="mt-1">{formatPointsValue(target.globalPts)} pts</p>
          {target.cityName ? (
            <p className="mt-1 text-xs text-guardians-muted">{target.cityName}</p>
          ) : null}
        </div>
        <p className="mt-6 font-mono text-2xl text-guardians-accent">{timerSec} сек</p>
        <p className="mt-2 max-w-xs text-xs text-guardians-muted">
          Энергия спишется только после принятия вызова соперником
        </p>
        {passport?.user_id === target.userId ? (
          <p className="mt-2 text-xs text-red-300">Это вы — отмените вызов</p>
        ) : null}
        <button
          type="button"
          onClick={handleCancel}
          className="mt-8 rounded-xl border border-red-400/40 px-6 py-2.5 text-sm text-red-200"
        >
          Отменить вызов
        </button>
      </div>
    </GameScreenLayout>
  )
}
